import React from 'react';
import { Box, Link, Typography } from '@mui/material';

import { useMaintenanceBanner } from '../../hooks';

export function MaintenanceBanner() {
  const message = useMaintenanceBanner();

  if (!message) return null;

  return (
    <Box sx={{ width: '100%', bgcolor: 'brand.red', color: 'white', p: 2, textAlign: 'center' }}>
      <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
        {message}: Please visit{' '}
        <Link sx={{ color: 'canvas.main' }} href="https://status.paragontruss.com">
          https://status.paragontruss.com
        </Link>{' '}
        for more information.
      </Typography>
    </Box>
  );
}
